import { render, staticRenderFns } from "./VelocityLogo.vue?vue&type=template&id=61bc82b5&scoped=true&"
var script = {}
import style0 from "./VelocityLogo.vue?vue&type=style&index=0&id=61bc82b5&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc82b5",
  null
  
)

export default component.exports